// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/status.index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/status.index.tsx");
  import.meta.hot.lastModified = "1735909117567.1995";
}
// REMIX HMR END

import { Container, Title, Text, Group, Stack, Alert, Badge, Button } from '@mantine/core';
import { defer } from '@remix-run/cloudflare';
import { fetchStatusEntriesUseCase } from '#app/modules/notion/use-cases/status';
import { Suspense } from 'react';
import { Await, Link, useLoaderData } from '@remix-run/react';
import { AwaitErrorElement, SkeletonLoader } from '#app/components/ui';
import { FormattedDate, FormattedTime } from 'react-intl';
import { metaTags } from '#app/root';
import { TbAlertCircle, TbInfoCircle, TbInfoTriangle } from 'react-icons/tb';
export const meta = () => {
  return metaTags({
    title: 'Status'
  });
};
export const headers = () => ({
  'Cache-Control': 'max-age=30'
});
export async function loader({
  request,
  context
}) {
  const entries = await fetchStatusEntriesUseCase();
  return defer({
    entries
  });
}
export function ErrorBoundary() {
  return <Container size="md">
			<Title order={1}>screenwork Status</Title>
			<Text mt="xs">
				Auf dieser Seite erhalten Sie laufende Updates und aktuelle Statusberichte zu den Produkten
				und Dienstleistungen von screenwork.
			</Text>

			<Alert color="red" title="Error" icon={<TbAlertCircle />} mt="lg">
				Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.
			</Alert>
		</Container>;
}
_c = ErrorBoundary;
export default function Status() {
  _s();
  const loaderData = useLoaderData();
  return <Container size="md">
			<Title order={1}>screenwork Status</Title>
			<Text mt="xs">
				Auf dieser Seite erhalten Sie laufende Updates und aktuelle Statusberichte zu den Produkten
				und Dienstleistungen von screenwork.
			</Text>

			<Suspense fallback={<SkeletonLoader mt="xl" />}>
				<Await resolve={loaderData.entries} errorElement={<AwaitErrorElement />}>
					{entries => entries ? <StatusList entries={entries} /> : <Alert color="red" title="Error" icon={<TbAlertCircle />}>
								Entries not found
							</Alert>}
				</Await>
			</Suspense>
		</Container>;
}
_s(Status, "ceKF1Gd7W4lGV+M78eBsU+KQIkw=", false, function () {
  return [useLoaderData];
});
_c2 = Status;
function StatusList(props) {
  const now = new Date();
  const openList = props.entries.filter(e => {
    if ((e.status == 'working' || e.status == 'open') && e.startDate) {
      const startDate = new Date(e.startDate);
      if (startDate < now) {
        return true;
      }
    }
    return false;
  }).sort((a, b) => {
    if (a.startDate && b.startDate) {
      return +new Date(a.startDate) - +new Date(b.startDate);
    }
    return 0;
  });
  const plannedList = props.entries.filter(e => {
    if (e.status == 'open' && e.startDate) {
      const startDate = new Date(e.startDate);
      if (startDate > now) {
        return true;
      }
    }
    return false;
  }).sort((a, b) => {
    if (a.startDate && b.startDate) {
      return +new Date(a.startDate) - +new Date(b.startDate);
    }
    return 0;
  });
  const doneList = props.entries.filter(e => e.status == 'done');
  return <>
			<Title mt="xl" order={2}>
				Aktuelle Meldungen
			</Title>
			<Stack mt="xs">
				{openList.map(e => <Incident key={e.id} id={e.id} severity={e.severity} title={e.title} startDate={e.startDate} endDate={e.endDate} status={e.status == 'working' ? 'working' : 'open'} />)}
			</Stack>

			<Title mt="xl" order={2}>
				Geplante Arbeiten
			</Title>
			<Stack mt="xs">
				{plannedList.map(e => <Incident key={e.id} id={e.id} severity={e.severity} title={e.title} startDate={e.startDate} endDate={e.endDate} status="planned" />)}
			</Stack>

			<Title mt="xl" order={2}>
				Erledigte Arbeiten
			</Title>
			<Stack mt="xs">
				{doneList.map(e => <Incident key={e.id} id={e.id} severity={e.severity} title={e.title} startDate={e.startDate} endDate={e.endDate} status="closed" />)}
			</Stack>
		</>;
}
_c3 = StatusList;
export function Incident(props) {
  let variant = 'filled';
  let color = 'red';
  let textColor = 'white';
  let icon = <TbAlertCircle />;
  let buttonVariant = 'white';
  if (props.severity == 'medium') {
    variant = 'filled';
    color = 'orange';
    textColor = 'white';
    icon = <TbInfoTriangle />;
  } else if (props.severity == 'low') {
    variant = 'outline';
    color = '';
    textColor = 'var(--color-text-color)';
    icon = <TbInfoCircle />;
    buttonVariant = 'outline';
  }
  const startDate = props.startDate ? new Date(props.startDate) : new Date();
  const endDate = props.endDate ? new Date(props.endDate) : undefined;
  return <Alert variant={variant} color={color} title={<Group>
					{props.title}
					{props.status == 'working' && <Badge color="blue">In Bearbeitung</Badge>}
				</Group>} icon={icon} styles={{
    title: {
      fontSize: 'var(--mantine-font-size-lg)'
    },
    icon: {
      width: 'var(--mantine-spacing-xl)',
      height: 'var(--mantine-spacing-xl)'
    }
  }}>
			<Stack>
				<Group justify="space-between" w="100%">
					<Group>
						<Text c={textColor}>
							Start:
							<FormattedDate format="short" value={startDate}></FormattedDate>
							&nbsp;
							<FormattedTime value={startDate}></FormattedTime>
						</Text>
						{(props.status == 'open' || props.status == 'planned') && <Text c={textColor}>
								Vorraussichtliches Ende:{' '}
								<FormattedDate format="short" value={endDate}></FormattedDate>
								&nbsp;
								<FormattedTime value={endDate}></FormattedTime>
							</Text>}
						{props.status == 'closed' && <Text c={textColor}>
								Ende: <FormattedDate format="short" value={endDate}></FormattedDate>
								&nbsp;
								<FormattedTime value={endDate}></FormattedTime>
							</Text>}
					</Group>
					{!props.disableButton && <Button component={Link} to={`/status/${props.id}`} size="xs" variant={buttonVariant}>
							Details
						</Button>}
				</Group>
			</Stack>
		</Alert>;
}
_c4 = Incident;
var _c, _c2, _c3, _c4;
$RefreshReg$(_c, "ErrorBoundary");
$RefreshReg$(_c2, "Status");
$RefreshReg$(_c3, "StatusList");
$RefreshReg$(_c4, "Incident");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;